/* The Trend and Prognoza row both two-dates stages draw. The pills themselves share `.preset`'s
 * rules in `DetailTab.module.css`; what is here is the row, and the one way Forma lays it out
 * differently (`layout="compact"`). */

/* Indented to the plot's own left gutter, so Trend and Prognoza begin where the line does rather
 * than where the card does. The inset is the plot margin's `left`, which lives in
 * `TwoDatesStageParts` because bklit computes its box from it — the two are the same 44px and the
 * comment is the only link available between a number JavaScript owns and a stylesheet. */
.toggleRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-6px);
  align-items: center;
  margin-block-start: var(--space-6px);
  padding-inline-start: var(--w-plot-gutter);
}

/* The refusals stand among the toggles on Pomiary. */
.reasons {
  display: contents;
  flex-basis: 100%;
  order: 1;
  min-height: calc(var(--fs-micro-label) * var(--lh-normal));
  font-size: var(--fs-micro-label);
  line-height: var(--lh-normal);
}

/* Forma's narrower stage gives the refusals a line of their own, reserved whether or not a toggle
 * is refused, so a refusal arriving with the answer never squeezes the instruction into more lines;
 * and the instruction wraps in the space left, as its canon draws it. */
.compact .reasons {
  display: block;
}

.compact .reason + .reason {
  margin-inline-start: var(--space-6px);
}

.compact .instruction {
  flex: 1 1 0;
  min-width: 0;
  line-height: var(--lh-hint);
  white-space: normal;
}
